<p *ngIf="!datasets[0].data.length && !infoNotAvailable "></p>
<div class="toggle-container quarterly-toggle-width" *ngIf="!isSmallScreen">
  <div class="c11n-segmented-control c11n-segmented-control--small c11n-segmented-control--ink">
    <fieldset class="c11n-segmented-control__fieldset">
      <legend class="c11n-segmented-control__legend">Please select one:</legend>
      <div class="c11n-segmented-control__segment" id="chart" (click)="onChange('chart')" [ngClass]="{'c11n-segmented-control__segment--active': displayToggle === 'chart'}">
        <input type="radio" id="segment-4" name="segment-group" value="chart" class="c11n-segmented-control__segment-input">
        <label for="segment-4" class="c11n-segmented-control__segment-label"><span>Chart</span></label>
      </div>
      <div class="c11n-segmented-control__segment" id="table" (click)="onChange('table')" [ngClass]="{'c11n-segmented-control__segment--active': displayToggle === 'table'}">
        <input type="radio" id="segment-5" name="segment-group" value="table" class="c11n-segmented-control__segment-input">
        <label for="segment-5" class="c11n-segmented-control__segment-label"><span>Table</span></label>
      </div>
    </fieldset>
  </div>
</div>
<div *ngIf="displayToggle=='chart'">
  <div class="container premium-discount-wrap" *ngIf="premiumDiscount;else noData">
    <span>
      <div>
        <div>
          <table class="premium-discount-table">
            <thead>
              <tr>
                <th><span>Name</span></th>
                <th><span>Date</span></th>
                <th><span>Market price</span></th>
                <th><span>NAV</span></th>
                <th><span>Premium/Discount</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span data-rpa-tag-id="symbol">{{ticker}}</span>
                </td>
                <td *ngIf="greaterThan(chartIndex)" >
                  <span data-rpa-tag-id="premiumDiscountDate">{{ premiumDiscount?.pdDetails[chartIndex]?.effectiveDate | ESTPipe }}
                  </span>
                </td>
                <td *ngIf="chartIndex===undefined ">
                  <span>{{ premiumDiscountCurrent?.effectiveDate | ESTPipe }}</span>
                </td>
                <td *ngIf="greaterThan(chartIndex)" >
                  <div class="legend" data-rpa-tag-id="priceMarket">
                    <div class=" legend-box legend-common legend-first"></div>
                    {{premiumDiscount?.pdDetails[chartIndex]?.marketPrice | currency:'USD':'symbol':'1.2-2' }}
                  </div>
                </td>
                <td *ngIf="chartIndex===undefined ">
                  <div class="legend" data-rpa-tag-id="priceMarket">
                    <div class=" legend-box legend-common legend-first"></div>
                    {{premiumDiscountCurrent?.marketPrice | currency:'USD':'symbol':'1.2-2' }}
                  </div>
                </td>
                <td *ngIf="greaterThan(chartIndex)" >
                  <div class="legend" data-rpa-tag-id="priceNAV">
                    <div class=" legend-box legend-common legend-second"></div>
                    {{premiumDiscount?.pdDetails[chartIndex]?.nav | currency:'USD':'symbol':'1.2-2' }}
                  </div>
                </td>
                <td *ngIf="chartIndex===undefined ">
                  <div class="legend" data-rpa-tag-id="priceNAV">
                    <div class=" legend-box legend-common legend-second"></div>
                    {{premiumDiscountCurrent?.nav | currency:'USD':'symbol':'1.2-2' }}
                  </div>
                </td>
                <td *ngIf="greaterThan(chartIndex)" ><span data-rpa-tag-id="premium">{{premiumDiscount?.pdDetails[chartIndex]?.premiumDiscountPercentage | number : '1.2-2' }}%</span></td>
                <td *ngIf="chartIndex===undefined "><span>{{premiumDiscountCurrent?.premiumDiscountPercentage | number : '1.2-2' }}%</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </span>
    <div class="col-lg-12 line-chart">
      <app-line-bar-chart-sync *ngIf="barDatasets[0].data.length" ariaLabel="A line graph that depicts Premium discount price information"  [datasets]="datasets" [barDatasets]="barDatasets" [labels]="barChatLabels" [shareSplitDate]="shareSplitDate" [shareSplitPrice]="shareSplitPrice" (chartMouseOut)="chartMouseOut()" (activeItemChanged)="activeItemChanged($event)" (dataUpdated)="onDataUpdated($event)"></app-line-bar-chart-sync>
    </div>
  </div>
</div>
<div class="row" *ngIf="displayToggle=='table'">
  <div class="horizontal-scroll-table" #horizontalScrollTable>
    <table class="table-results table-hover" aria-label="Premium/Discount table">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col" style="white-space: nowrap;">Market price</th>
          <th scope="col">NAV</th>
          <th scope="col">Premium/Discount</th>
          <th scope="col" class="spacer" aria-hidden="true"></th>
          <ng-container *ngIf="isSmallScreen">
            <button class="right-btn" aria-label="Scroll Right" (click)="moveRight()" *ngIf="showRightButton">
              &RightAngleBracket;
            </button>
            <button class="left-btn" aria-label="Scroll Left" (click)="moveLeft()" *ngIf="scrollBarPosition > 0">
              &LeftAngleBracket;
            </button>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pd of premiumDiscountData" [attr.data-rpa-tag-id]=" 'pr-pdc-row-' + (pd?.effectiveDate | ESTPipe) ">
          <td data-rpa-tag-id="pr-pdc-asOfDate">{{pd?.effectiveDate | ESTPipe }}</td>
          <td data-rpa-tag-id="pr-pdc-mkt-price">{{pd?.marketPrice | currency:'USD':'symbol':'1.2-2' }}</td>
          <td data-rpa-tag-id="pr-pdc-nav-price">{{pd?.nav | currency:'USD':'symbol':'1.2-2' }}</td>
          <td data-rpa-tag-id="pr-pdc-premium">{{pd?.premiumDiscountPercentage | number : '1.2-2' }}%</td>
          <td class="spacer" aria-hidden="true"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="pagination-view container-fluid"  [ngClass]="{'flex-row-reverse':!isMobileDevice,'flex-column':isMobileDevice}">
    <vmf-pagination class="select-value" [paginationLabel]="modelLabel" (newPageNumber)="setPageNumber($event)"  [listSize]="premiumDiscount?.pdDetails.length"></vmf-pagination>
  </div>
</div>
<ng-template #noData>
  <div [hidden]="infoNotAvailable">
    <no-data></no-data>
  </div>
</ng-template>
